import React from 'react';
import { useTranslation } from 'react-i18next';
import entityViewStyles from '@lib/assets/styles/EntityView.module.scss';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import { materialSymbolsOutlined } from '@lib/enums/common';
import Tooltip from '@lib/components/Tooltip/Tooltip';

type Props = {
  canDestroy?: boolean;
  onDeleteHandler: () => void;
};

export default function SectorViewBottomActions({
  canDestroy,
  onDeleteHandler,
}: Props) {
  const { t } = useTranslation();
  return (
    <div className={entityViewStyles.actions}>
      {canDestroy ? (
        <Button
          buttonText={t('delete-sector')}
          buttonType={ButtonTypes.negativeOutlined}
          leftIcon="delete"
          leftIconClassName={materialSymbolsOutlined}
          onClick={onDeleteHandler}
        />
      ) : (
        <Tooltip body={t('sector-disabled-destroy-desc')}>
          <Button
            buttonText={t('delete-sector')}
            buttonType={ButtonTypes.negativeOutlined}
            leftIcon="delete"
            leftIconClassName={materialSymbolsOutlined}
            disabled
          />
        </Tooltip>
      )}
    </div>
  );
}
